<template>
    <div class="bg-white">
    
        <!-- <CCol sm="12" lg="8" class="mx-auto" style="width: 70%; background-size: cover; color: #fff;">
                <div>
                    <CRow>
                        <CCol sm="8" style="margin:0 auto">
                            <div style="margin-top: 15%;">
                                <CCard class="b-20">
                                    <h3 class="text-center text-black mt-5">Welcome Back</h3>
        
                                    <CCol sm="12" style="width: 70%; background-size: cover; margin: auto; color: #fff;">
                                        <CRow class="mt-5">
                                            <div v-if="this.Error == true" class="ml-1 mr-1 mt-2 mb-2">
                                                <CAlert show color="danger" class="custom-error-message">The credentials entered is incorrect.Please try again.</CAlert>
                                            </div>
                                            <CCol sm="12">
                                                <h3 class="custom-14px">Email Address</h3>
                                                <CInput type="text" class="custom-input b-50" v-model="Email" />
                                            </CCol>
                                            <CCol sm="12">
                                                <h3 class="custom-14px">Password</h3>
                                                <CInput type="password" class="custom-input b-50" v-model="Password" />
                                            </CCol>
                                            <CCol sm="12">
                                                <div class="text-right">
                                                    <label class="custom-16px-600">
                                                            I forgot my password
                                                        </label>
                                                </div>
                                            </CCol>
                                            <CButton type="button" class="bg-button-blue text-white m-2" block v-on:click="trylogin">Login</CButton>
                                        </CRow>
                                        <CRow>
                                            <img src="../assets/img/loginwith.png" style="max-width:100%" />
                                            <div style="width:50%">
                                                <div class="text-center bg-grey b-20 p-2 m-20" style="border:none;margin:10px" @click="login">
                                                    <img style="width:25px" src="../assets/img/google1.png" class="mt-1 mb-1 mr-2" />
                                                </div>
                                            </div>
                                            <div style="width:50%">
                                                <div class="text-center bg-grey b-20 p-2 m-20" style="border:none;margin:10px">
                                                    <img style="width:25px" src="../assets/img/apple1.png" class="mt-1 mb-1 ml-2" />
                                                </div>
                                            </div>
        
                                        </CRow>
                                        <div class="text-center mt-3">
                                            <label class="custom-14px poppin-font"> Don’t have an account? <a href="CreateAccount">Create Now</a></label>
                                        </div>
                                    </CCol>
        
                                    <div class="mt-4">
                                        <div class="inline-container">
        
                                            <span class="text-center text-black" style="margin-left:40%">{{ lblGoogle }}</span>
        
                                        </div>
                                    </div>
        
        
                                </CCard>
                                <br /><br />
                            </div>
                        </CCol>
                    </CRow>
                </div>
            </CCol> -->
    
        <div>
            <CRow class="g-3">
                <CCol sm="6" lg="6">
                    <div class="p-2">
                        <div style="background-position: center;background-size: cover; min-height: 100vh;border-radius:18px" :style="{ backgroundImage: `url(${backgroundUrl})` }"></div>
                    </div>
                </CCol>
    
                <CCol sm="6">
                    <CRow class="p-2">
                        <CCol sm="8"></CCol>
                        <CCol sm="4">
                            <img src="../assets/img/Logo.png" height="32" alt="Interviewrr.ai company logo" class="mt-2"/> <span class="custom-20px-500 text-white"></span>
                        </CCol>
    
                    </CRow>
    
                    <CContainer style="max-width: 600px; text-align: left;">
                        <div>
                            <h3 class="custom-24px-600 font-color-171717 text-left">Create a new account</h3>
                            <p class="custom-18px-500"><span class="font-color-666D80">Enter your details to sign up</span></p>
                        </div>
    
                        <div class="mt-3">
                            <CRow>
                                <CCol sm="12">
                                    <strong class="text-left mt-2 mb-2 custom-14px-400 font-inter font-color-171717"> Name</strong>
                                <CInput type="text" v-model="name" />
                                </CCol>
                                
                                <CCol sm="12">
                                    <strong class="text-left mt-2 mb-2 custom-14px-400 font-inter font-color-171717">Email</strong>
                                <CInput type="text" v-model="email" />
                                </CCol>
                                <CCol sm="12">
                                    <strong class="text-left mt-2 mb-2 custom-14px-400 font-inter font-color-171717">Phone</strong>
                                <CInput type="text" v-model="phone" />
                                </CCol>
                                <CCol sm="12">
                                    <strong class="text-left mt-2 mb-2 custom-14px-400 font-inter font-color-171717">Password</strong>
                                <CInput type="password" v-model="password" />
                                </CCol>
                                <CCol sm="12">
                                   
                                <div class="text-center mt-4 mb-2">
                            <CButton class="button-Explore text-white custom-border-radius-12px" v-on:click="registerAccount" block size="lg">Register</CButton>
                        </div>
                                </CCol>
                               
                               
                            </CRow>
                        </div>
    
    
                     
                        <img src="../assets/img/or1.png" style="max-width:100%" class="mb-2 mt-2" />
    
                        <div v-if="ErrorLogin" class="">
                            <CAlert show color="danger">
                                <strong class="text-danger mr-2">Error!</strong> {{ Message }}
                            </CAlert>
                        </div>
    
                        <div class="custom-btn-white mt-4">
                            <div class="text-center" v-on:click="login">
                                <img src="../assets/img/google1.png" alt="Google Login" style="max-width:20px" />
                                <span class="custom-14px-600 font-color-171717 ml-2">{{ lblGoogle }}</span>
                            </div>
                        </div>

                        <div class="custom-btn-white mt-2" style="background:lightgrey;cursor:not-allowed">
                            <div class="text-center">
                                <img src="../assets/img/fb.png" alt="Google Login" style="max-width:20px" />
                                <span class="custom-14px-600 font-color-grey ml-2">{{ lblFb }}</span>
                            </div>
                        </div>

                        <div class="custom-btn-white mt-2" style="background:lightgrey;cursor:not-allowed">
                            <div class="text-center">
                                <img src="../assets/img/iconapple.png" alt="Google Login" style="max-width:20px" />
                                <span class="custom-14px-600 font-color-grey ml-2">{{ lblApple }}</span>
                            </div>
                        </div>
    
    
    
                      
                        <CCol sm="12" class="text-center">
                            <p class="text-center custom-16px-500 font-color-171717 mt-3">Already have an account? <label class="font-color-064BB4" @click="GoToLoginType()">Sign In</label></p>
                        </CCol>

                      
    
    
    
    
    
    
                    </CContainer>
                </CCol>
    
    
            </CRow>
    
        </div>
    
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgloginsport.png";
import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";


import GAuth from 'vue-google-oauth2'
import SignUp from "./SignUp.vue";

const gauthOption = {
    clientId: '435242184873-lfkbjg7vnqp31opg3qgnn1u0pf0ve5kt.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout
    },

    data() {
        return {
            backgroundUrl: backgroundUrl,
            Error: false,
            lblGoogle: "Sign up with Google",
            lblFb: "Sign up with Facebook",
            lblApple: "Sign up with Apple",

            selectedType: false,
            name:"",
            email: "",
            phone: "",
            password: "",
            ErrorLogin: false

        };
    },
    created() {
        AOS.init();
    },
    methods: {

        trylogin() {
            this.Error = false;

            const formData = new FormData();

            if (this.Email === "" || this.Password === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                formData.append("Email", this.Email);
                formData.append("Password", this.Password);

                this.$API
                    .post(this.$LoginToken, formData, { withCredentials: true })
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                        if (response.status == 200) {
                            if (response.data.status !== 400) {
                                this.$router.push("Profile");
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Error = true;
                            this.Message = response.data.message;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                    });
            }
        },
        async login() {
            this.lblGoogle = "Google";
            try {
                var googleuser = await this.$gAuth.signIn(); // Wait for signIn() method to complete
                this.isLogin = this.$gAuth.isAuthorized; // Update isLogin status after successful signIn
                console.log('Is user logged in?', this.isLogin);
                var idToken = googleuser.getAuthResponse().id_token;
                console.log("getProfile" + googleuser.getBasicProfile());
                console.log("auth" + googleuser.getAuthResponse());
                console.log("auth" + this.$gAuth.GoogleAuth.currentUser.get().getAuthResponse());




                // If the user is logged in, retrieve the user profile to access the email
                if (this.isLogin) {
                    console.log('ID Token:', idToken);

                    var authResponse = googleuser.getAuthResponse();
                    var accessToken = authResponse.access_token;
                    var idToken = authResponse.id_token;

                    console.log('ID Token:', idToken);
                    console.log('Access Token:', accessToken);

                    // Verify if the token includes the scope
                    await this.verifyScopes(accessToken);

                    // Fetch user phone and address info
                    const userInfo = await this.getUserInfo(accessToken);
                    console.log('User Info:', userInfo);

                    const userName = userInfo.displayName;
                    this.getUserEmail(idToken, userName);
                }
            } catch (error) {
                console.error('Error during login:', error);
            }
        },
        async verifyScopes(accessToken) {
            try {
                const response = await fetch(`https://www.googleapis.com/oauth2/v3/tokeninfo?access_token=${accessToken}`);
                const tokenInfo = await response.json();

                console.log('Token Info:', tokenInfo);

                if (tokenInfo.scope.includes('https://www.googleapis.com/auth/user.phonenumbers.read')) {
                    console.log('Scope is present in the token.');
                } else {
                    console.error('Scope is missing in the token.');
                }
            } catch (error) {
                console.error('Error verifying scopes:', error);
            }
        },
        async getUserInfo(accessToken) {
            try {
                const response = await fetch('https://people.googleapis.com/v1/people/me?personFields=phoneNumbers,addresses,emailAddresses,names', {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                const userData = await response.json();

                console.log('User Data:', userData);

                const phoneNumber = userData.phoneNumbers ?.length > 0 ? userData.phoneNumbers[0].value : 'No phone number available';
                const country = userData.addresses ?.length > 0 ? userData.addresses[0].country : 'No country information available';
                const displayName = userData.names ?.length > 0 ? userData.names[0].displayName : 'No display name available';

                return { phoneNumber, country, displayName };
            } catch (error) {
                console.error('Error fetching user info:', error);
                return { phoneNumber: 'Error', country: 'Error' };
            }
        },
        async getUserEmail(idToken, username) {
            this.lblGoogle = "Google";
            try {
                const response = await this.$API.get(this.$GetTokenEmail + "?idToken=" + idToken);
                if (response.status === 200) {
                    this.user = response.data;
                    this.SetSession(idToken, this.user, username);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToLoginType()
        {
            this.$router.push("LoginAccount")
        },
        registerAccount() {
            this.lblProgress = "Processing";

            const formData = new FormData();

            if (this.name === "" || this.email === "" || this.password === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("name", this.name);
                formData.append("email", this.email);
                formData.append("phone", this.phone);
                formData.append("userType", "user");
                formData.append("password", this.password);

                this.$API
                    .post(this.$SignUp, formData, { withCredentials: true })
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;

                        }
                        if (response.status == 200) {

                            if (response.data.status !== 400) {

                                    if (
                                        this.$route.query.targetUrl != "" &&
                                        (this.$route.query.targetUrl != null) &
                                        (this.$route.query.targetUrl != undefined)
                                    ) {
                                        this.$router.push(this.$route.query.targetUrl);
                                    } else {
                                       // this.isLanguagePopupVisible1 = true;
                                       this.$router.push("LoginAccount");
                                    }
                             

                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                                this.MessageError = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Error = true;
                            this.Message = response.data.message;
                            this.MessageError = true;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                        this.MessageError = true;
                    });
            }
        },
        async SetSession(idToken, user, username) {
    this.lblGoogle = "Processing";
    console.log("username:" + username);
    try {
        const response = await this.$API.get(this.$InsertSession + "?idToken=" + idToken);
        console.log("Response:", response);
        if(response.status === 202)
        {
          //  this.$router.push("LoginType?email=" + user + "&username=" + username + "&idToken=" + idToken); 
          this.registerAccountGoogleUser(user,username,idToken);
            this.SetSession(idToken, user, username);
        }
        if (response.status === 200) {
            const userData = response.data; // Access response.data
            console.log("User Data:", userData);
            const userType = userData.userType; // Correctly access userType
            console.log("User Type:", "user");
            await this.delay(5000);

            // Authenticate the user
            const isAuth = await this.UserAuth();
            if (isAuth) {
                // Redirect based on userType
                if (userType === '-') {
                    this.$router.push("Profile");
                } else if (userType === 'user') {
                    this.$router.push("Profile");
                } else {
                    this.$router.push("Dashboard");
                }
            } else {
                this.lblGoogle = "Google";
                this.GoToLogin();
            }
        } else {
            this.lblGoogle = "Google";
            console.error("Unexpected status code:", response.status);
        }
    } catch (error) {
        console.error("Error fetching user information:", error);
        this.lblGoogle = "Google";
        // Handle the error (e.g., show an error message)
    }
},
        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        registerAccountGoogleUser(user,username,idToken) {
            this.showProgress = true;
            const formData = new FormData();
    formData.append("name", username);
    formData.append("email", user);
    formData.append("userType", "user");




    this.$API
        .post(this.$SignUp, formData, { withCredentials: true })
        .then((response) => {
            if (response.data.status === 400) {
                this.Loading = false;
                this.Message = response.data.message;
                this.Error = true;

            }
            if (response.status == 200) {

                alert('Please update your phone number on your profile');
               
                this.SetSession(idToken, user,username);
            } else {
                this.Loading = false;
                this.Error = true;
                this.Message = response.data.message;
            }
        })
        .catch((error) => {
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
        });
},


    }

};
</script>

<style scoped>

</style>